import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stepper,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import {
  ENTITY_NAME,
  TEMPLATE_DATA,
  TEMPLATE_NAME,
  UPLOAD_IMPORT_DATA,
} from "../../facility-management-screen/constants";
import { VALIDATION_CONSTANTS } from "../../../utils/validation-constants/validationConstants";
import Input from "../../../component-lib/Atoms/Input/Input";
import Button from "../../../component-lib/Molecules/button/Button";
import { TEXT_CONSTANTS } from "../../../utils/text-constants/textConstants";
import SelectDropdown from "../../../component-lib/Atoms/Select/Select";
import { styled } from "@mui/material/styles";
import StepperForDataImport from "./stepper&csv-file-uploader/StepperForDataImport";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: "0px 24px 16px 24px",
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiPaper-root": {
    BorderAllRounded: "8px",
    Height: "822px",
    width: "900px",
    maxWidth: "none",
  },
}));

interface UploadImportDialogProps {
  isOpen: boolean;
  handleData: (data: any) => void;
  handleClose: () => void;
}

export default function UploadImport({
  isOpen = false,
  handleClose,
  handleData,
}: UploadImportDialogProps) {
  const validationSchema = Yup.object().shape({
    [UPLOAD_IMPORT_DATA?.ENTITY_NAME]: Yup.string().required(
      "This Field is required"
    ),
  });

  const [selectedType, setSelectedType] = useState(false);
  const [file, setFile] = useState<File | null>(null);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);

  // Handle file upload
  const handleFileUpload = (uploadedFile: File) => {
    setFile(uploadedFile);
  };

  const handleFileRemove = () => {
    setFile(null);
    setSelectedFile(null);
  };

  return (
    <BootstrapDialog
      onClose={(event, reason) => {
        if (reason !== "backdropClick") {
          handleClose();
        }
      }}
      aria-labelledby="customized-dialog-title"
      open={isOpen}
    >
      <Formik
        initialValues={{
          [UPLOAD_IMPORT_DATA?.ENTITY_NAME]: "",
          file: null,
          //fileName: "",
        }}
        validationSchema={validationSchema}
        enableReinitialize
        onSubmit={(values, { setSubmitting }) => {
          try {
            const formData = { ...values, file };
            handleData(formData);
          } catch (error) {
            console.error("Error:", error);
          } finally {
            setSubmitting(false);
          }
        }}
      >
        {({
          errors,
          values,
          touched,
          isValid,
          dirty,
          setFieldValue,
          handleBlur,
          handleSubmit,
        }) => {
          return (
            <Form onSubmit={handleSubmit}>
              <DialogTitle
                sx={{
                  m: 0,
                  p: 2,
                  fontWeight: 600,
                  fontSize: "18px",
                  fontFamily: "inter",
                }}
                id="customized-dialog-title"
              >
                {"Upload"}
              </DialogTitle>
              <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={(theme) => ({
                  position: "absolute",
                  right: 8,
                  top: 8,
                  color: theme.palette.grey[500],
                })}
              >
                <CloseIcon />
              </IconButton>
              <hr />
              {/* MAIN CONTENT */}
              <DialogContent>
                <div
                  style={{
                    overflow: "auto",
                    display: "grid",
                    gridTemplateColumns: "1fr",
                    gap: "16px",
                  }}
                >
                  <div className="pt-4">
                    <SelectDropdown
                      label="Entity Type"
                      name={UPLOAD_IMPORT_DATA.ENTITY_NAME}
                      value={values[UPLOAD_IMPORT_DATA.ENTITY_NAME] ?? ""}
                      options={ENTITY_NAME}
                      onChangeCb={(e) => {
                        const selectedValue = e.target.value as string;
                        setFieldValue(
                          UPLOAD_IMPORT_DATA.ENTITY_NAME,
                          selectedValue
                        );
                        setSelectedType(Boolean(selectedValue));
                      }}
                      onBlur={handleBlur}
                      error={
                        touched[UPLOAD_IMPORT_DATA.ENTITY_NAME] &&
                        Boolean(errors[UPLOAD_IMPORT_DATA.ENTITY_NAME])
                      }
                      helperText={
                        touched[UPLOAD_IMPORT_DATA.ENTITY_NAME]
                          ? errors[UPLOAD_IMPORT_DATA.ENTITY_NAME]
                          : undefined
                      }
                    />
                  </div>
                </div>
                <div className="mt-4">
                  {selectedType && (
                    <StepperForDataImport
                      onFileUpload={handleFileUpload}
                      handleFileRemoveCb={handleFileRemove}
                      selectedFile={selectedFile}
                      // Pass file removal state
                      setSelectedFile={setSelectedFile}
                    />
                  )}
                </div>
              </DialogContent>
              {/* ACTION BUTTON */}
              <DialogActions style={{ padding: "24px" }}>
                <Button
                  //   disabled={!isValid} // Button disabled if form is invalid or submitting
                  type="submit"
                  label={TEXT_CONSTANTS?.SAVE}
                  variant="contained"
                  onClickCb={() => {}}
                  style={{
                    width: "200px",
                    height: "44px",
                    padding: "12px 20px",
                    fontSize: "16px",
                  }}
                ></Button>
              </DialogActions>
            </Form>
          );
        }}
      </Formik>
    </BootstrapDialog>
  );
}
